import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=3d8def22&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
import style0 from "./Label.vue?vue&type=style&index=0&id=3d8def22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8def22",
  null
  
)

export default component.exports